import { render, staticRenderFns } from "./month-invoices.renderer.vue?vue&type=template&id=364b31a7&scoped=true&"
import script from "./month-invoices.renderer.vue?vue&type=script&lang=js&"
export * from "./month-invoices.renderer.vue?vue&type=script&lang=js&"
import style0 from "./month-invoices.renderer.vue?vue&type=style&index=0&id=364b31a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b31a7",
  null
  
)

export default component.exports